import { ReactElement } from 'react';
import { WaterCard } from './components/WaterCard';
import { TrendsCard } from './components/TrendsCard';
import { EnergyEfficiencyCard } from './components/EnergyEfficiencyCard';

export function RowCardsOverview({ hasWater, loading }: Readonly<{ hasWater: boolean, loading: boolean }>): ReactElement {
  return (
    <div style={{
      display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 16,
    }}
    >
      <WaterCard hasWater={hasWater} loading={loading} />
      <TrendsCard loading={loading} />
      <EnergyEfficiencyCard loading={loading} />
    </div>
  );
}
